import {
  Github,
  Google,
  MicrosoftLogo,
  SlackLogo,
  Telegram,
  XIcon,
} from '@ankr.com/ui';

import { Auth0Logo } from 'modules/oauth/components/Auth0Logo';
import { useAuth } from 'modules/auth/hooks/useAuth';

export interface OauthIconProps {
  className?: string;
}

export const OauthIcon = ({ className }: OauthIconProps) => {
  const {
    isAuth0,
    isGithubAuth,
    isMicrosoftAuth,
    isSlackAuth,
    isTelegramAuth,
    isXAuth,
  } = useAuth();

  if (isGithubAuth) {
    return <Github className={className} />;
  }

  if (isAuth0) {
    return <Auth0Logo className={className} sx={{ '&&': { fontSize: 32 } }} />;
  }

  if (isMicrosoftAuth) {
    return <MicrosoftLogo className={className} />;
  }

  if (isTelegramAuth) {
    return <Telegram className={className} />;
  }

  if (isSlackAuth) {
    return <SlackLogo className={className} />;
  }

  if (isXAuth) {
    return <XIcon className={className} />;
  }

  return <Google className={className} />;
};
